<template>
  <div class="table-data">
    <!-- 搜索 -->
    <div class="search-box">
      <el-button
        class="primary-search-btn"
        type="primary"
        size="mini"
        @click="add()"
        >新增</el-button
      >
    </div>
    <!-- 列表 -->
    <el-table
      :data="tableData"
      style="width: 100%;margin-bottom: 20px;text-align:center"
      row-key="id"
      border
      :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
      <el-table-column
        prop="text"
        label="菜单名称"
        sortable
        width="250">
      </el-table-column>
      <el-table-column
        prop="orderNum"
        label="排序"
        sortable
        width="80">
        <template slot-scope="scope">
           <span
            size="small"
            type="text"> 
            {{scope.row.attr.orderNum}} 
            </span>
         </template> 
      </el-table-column>
      <el-table-column
        prop="resourceUrl"
        label="请求地址"
        sortable
        width="180">
        <template slot-scope="scope">
           <span
            size="small"
            type="text"> 
            {{scope.row.attr.resourceUrl}} 
            </span>
         </template> 
      </el-table-column>
      <el-table-column width="80" label="类型" prop="type" >
         <template   slot-scope="scope">
           <span
            size="small"
            type="text"
            style="display:block;border:1px solid red;color:red;width: 45px;height:20px;text-align:center"
            v-if="scope.row.attr.type == 1"> 
            目录 
            </span>
          <span
            size="small"
            type="text"
            style="display:block;border:1px solid green;color:green;width: 45px;height:20px;text-align:center"
            v-if="scope.row.attr.type == 2"> 
            菜单 
          </span>
          <span
            size="small"
            type="text"
            style="display:block;border:1px solid purple;color:purple;width: 45px;height:20px;text-align:center"
            v-if="scope.row.attr.type == 3"> 
            按钮 
          </span>
         </template>  
      </el-table-column>
      <el-table-column
        width="180" 
        prop="resourcePerms"
        label="权限标识">
        <template slot-scope="scope">
           <span
            size="small"
            type="text"> 
            {{scope.row.attr.resourcePerms}} 
            </span>
         </template> 
      </el-table-column>
      <el-table-column label="操作" >
        <template slot-scope="scope">
          <el-button
            @click="addmenu(scope.row)"
            size="small"
            type="text"
            >新增</el-button
          >
          <el-button
            @click="roledelete(scope.row.id)"
            size="small"
            type="text"
            >删除</el-button
          >
           <el-button
            @click="modify(scope.row)"
            size="small"
            type="text"
            >修改</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 新增修改区域 -->
    <el-dialog :title="isEdit?'修改菜单':'新增菜单'"
      :visible.sync="modal"
      :close-on-click-modal="false">
      <el-form :inline="true"
          label-width="200px"
          style="overflow:auto;text-align:center"
          class="dialog-hei" ref="formItem"  :rules="newRuler" :model="formItem">
        <div style="height:350px;padding: 20px 0 0 0;">
          <el-form-item label="上级菜单:">
            <div class="d-i-b">
                <span  style="padding: 5px 60px;border:solid 1px #E8E8E8;background-color: #E8E8E8"  @click="menu">{{menumName}}</span>
                </el-input>
              </div>
              
          </el-form-item>
          <el-form-item label="权限字符:" prop="type">
              <el-radio-group v-model="formItem.type">
                <el-radio  label="1">目录</el-radio>
                <el-radio  label="2">菜单</el-radio>
                <el-radio  label="3">按钮</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="菜单名称:" prop="resourceName">
              <el-input v-model="formItem.resourceName" placeholder="请输入菜单名称" style="width:160px"></el-input>
          </el-form-item>
          <el-form-item label="请求地址:" prop="resourceUrl" v-if="formItem.type == 2">
              <el-input v-model="formItem.resourceUrl" placeholder="请输入请求地址" style="width:160px"></el-input>
          </el-form-item>
          <el-form-item label="权限标识:" prop="resourcePerms" v-if="formItem.type != 1">
              <el-input v-model="formItem.resourcePerms" placeholder="请输入权限标识" style="width:160px"></el-input>
          </el-form-item>
          <el-form-item label="显示排序:" prop="orderNum">
              <el-input v-model="formItem.orderNum" placeholder="请输入排序" style="width:160px"></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer">
        <el-button type="text" @click="modal = false">取消</el-button>
        <el-button type="primary" @click="ok('formItem')" :loading="loading">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="菜单选择"
      :visible.sync="menutree"
      :close-on-click-modal="false">
      <el-form :inline="true"
          label-width="100px"
          class="dialog-hei">
        <div style="height:300px;padding: 20px 0 0 0;">
          <el-form-item label="关键字:">
            <div class="d-i-b">
                <el-input
                placeholder="输入关键字进行过滤"
                v-model="filterText">
              </el-input>
            </div>   
          </el-form-item>
          <div style="height:310px;overflow:auto;">
             <el-form-item>
            <div style="width:200px;text-align:center;line-height;">
              <el-tree
                :props="props"
                :data="tree"
                default-expand-all
                node-key="id"
                :expand-on-click-node="false"
                :filter-node-method="filterNode"
                ref="tree">
              </el-tree>
            </div>
            </el-form-item >
          </div> 
        </div>
      </el-form>
      <div slot="footer">
        <el-button type="text" @click="menutree = false">取消</el-button>
        <el-button type="primary" @click="determine" :loading="loading">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template> 
<script>
// import {treeall,resourcesave,resourceupdate,resourcedelete,resourcegetOne} from '@/api/jurisdiction'
export default {
  data() {
    return {
      loading: false,
      isEdit: false,
      modal: false,
      menutree:false,
      list: [],
      total: 0,
      title: "新增角色",
      menumName:'主目录',
      tableData:[],
      formItem: {
        resourceName:"",
        parentResourceId:'0',
        resourceUrl:'',
        type:'',
        orderNum:'',
        resourcePerms:'',
        icon:'',
        format:'',
        // typetwo:'1'
        
      },
      newRuler:{
        resourceName:[{required: true, message: '请输入菜单名称', trigger: 'blur'}],
        type:[{required: true, message: '请选择菜单类型', trigger: 'blur'}],
        orderNum:[{ required: true, message: '请输入排序', trigger: 'blur' }],
        resourceUrl:[{ required: true, message: '请输入请求地址', trigger: 'blur' }],
        resourcePerms:[{required: true, message: '请输入权限标识', trigger: 'blur'}]
      },
      searchData: {
        roleName: "",
        roleId: "",
        pageindex: 1,
        pagesize: 10,
      },
      props: {
        children: 'children',
        label: 'text'
      },
      tree: [],
      filterText: '',
    };
  },
  created() {
    this.getTableList();
    this.tHeight = document.body.offsetHeight - 230;
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.text.indexOf(value) !== -1;
    },
    async getTableList() {
      let res =  await treeall();
      this.tableData = res.children?res.children:[];
      this.tree = res.children?res.children:[];
      this.iteration(this.tableData);
    },
    // 递归循环
    iteration(data) {
      for (var j = 0; j < data.length; j++) {
        delete data[j].hasChildren;
        if (data[j].children != null && data[j].children.length > 0) {
          this.iteration(data[j].children)
        }
      }
      console.log(this.tableData);
    },
    //删除
    roledelete(id){
      this.$confirm("确定删除当前数据么？", "删除", {
        type: "warning",
      })
        .then(() => {
          let res = resourcedelete({resourceId:id});
          this.$message({
              type:'success',
              message:'删除成功'
          });
          setTimeout(() => {
            this.getTableList();
          }, 300);
          
        })
        .catch((e) => {
          console.log(e);
        });
      
    },
    add() { //添加菜单信息
      this.formItem ={};
      this.menumName = "";
      this.modal = true;
      this.isEdit = false;    
    },
    //列表新增菜单
    async addmenu(row){
      this.modal = true
      this.isEdit = false
      this.formItem={};
      let res =  await resourcegetOne({resourceId:row.id});
      this.formItem.parentResourceId = res.resourceId
      this.menumName = res.resourceName
    },
    menu (){ //获取资源树 
        this.menutree = true;  
    },
    async modify(list){ //修改菜单信息
      let res =  await resourcegetOne({resourceId:list.id}); 
      this.formItem = res;
      if(this.formItem.parentResourceName){
        this.menumName = this.formItem.parentResourceName
      }else{
        this.menumName = "无"
      } 
      this.formItem.type =  this.formItem.type.toString();
      this.modal = true
      this.isEdit = true
    },
    determine(){ //菜单树选择
      var idList = this.$refs.tree.getCurrentNode(); 
      this.formItem.parentResourceId = idList.id;
      this.menumName = idList.text;
      this.menutree = false; 

    },
    ok(formName) { //更新菜单信息
      this.$refs[formName].validate(async valid => {
          if (!valid) return;
        if(this.isEdit){
          let newlist = { //更新的信息
              resourceId:this.formItem.resourceId,
              resourceName:this.formItem.resourceName,
              resourceUrl:this.formItem.resourceUrl,
              resourcePerms:this.formItem.resourcePerms,
              type:this.formItem.type,
              icon:this.formItem.icon,
              orderNum:this.formItem.orderNum,
            }             
          let res = resourceupdate(newlist);
          this.modal = false;
          this.$message({
              type:'success',
              message:'修改成功'
          });
          setTimeout(() => {
            this.getTableList();
          }, 300);
        }else{
          let res = resourcesave(this.formItem);
          this.modal = false;
          this.$message({
              type:'success',
              message:'新增成功'
          });
          setTimeout(() => {
            this.getTableList();
          }, 300);
        }
      })
    },
    cancel() {
      this.modal = false;
      this.$refs["formItem"].resetFields();
      this.$Message.info("操作取消");
    },
  },
};
</script>

<style lang="scss">
.el-tree__empty-text {
  position:static;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
  color: #909399;
  font-size: 14px;
}
</style>